/**
 * O arquivo escolhido na lista de cotações, a caminho da tela de importação.
 *
 * O comprador clica em "Importar planilha do ERP" e escolhe o arquivo ali
 * mesmo; a tela de importação abre já com ele. Um File não atravessa o state
 * do react-router com segurança, e guardá-lo numa store global seria dar
 * permanência a algo que dura um clique — então mora aqui, e quem lê, apaga.
 */
let pendente: File | null = null;

export function guardarArquivo(arquivo: File): void {
  pendente = arquivo;
}

export function retirarArquivo(): File | null {
  const arquivo = pendente;
  pendente = null;

  return arquivo;
}
